<template>
    <ul>
        <li class="hover:bg-gray-100">
            <router-link to="/profile" tag="a" class="flex block px-4 pt-2 pb-3 font-semibold rounded-b-lg cursor-pointer">Edit my info</router-link>
        </li>
        <li class="hover:bg-gray-100" v-if="$store.getters['orgs/isAdmin']">
            <a class="flex block px-4 pt-2 pb-3 font-semibold rounded-b-lg cursor-pointer">Transfer ownership</a>
        </li>
        <li @click="$emit('leave', $event)" class="text-red-500 hover:bg-gray-100" v-else>
            <a class="flex block px-4 pt-2 pb-3 font-semibold rounded-b-lg cursor-pointer ">Leave organization</a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'modify-self',
};
</script>
